require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-ويب-ديزاين.json") })
        }
      }, "path---tags-ويب-ديزاين");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-ويب-ديزاين!./.cache/json/tags-ويب-ديزاين.json
// module id = 623
// module chunks = 231608221292675